import { render, staticRenderFns } from "./listUsuarios.vue?vue&type=template&id=5a95c69a"
import script from "./listUsuarios.vue?vue&type=script&lang=js"
export * from "./listUsuarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports